/**
 * @desc findUserByUserCode
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(
  params: API.ucenter.userFacadeImpl.findUserByUserCode.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/user/findUserByUserCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
